export default __webpack_public_path__ + "static/media/step_B.cee96bf5.png";